 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		3: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~vue~vue-component-cart-item-qty~vue-component-gallery-carousel~vue-component-image-zoom~vue-~239075a3","1":"vendors~vue-component-gallery-carousel~vue-component-highlighted-list-carousel~vue-component-room-ca~c5555909","2":"vendors~vue-component-book-tool~vue-component-date-picker","8":"vendors~vue-component-products-overview","9":"vue-component-age-checker","10":"vue-component-background-hover","11":"vue-component-book-table-tool","12":"vue-component-book-table-tool-mobile","13":"vue-component-book-tool","14":"vue-component-book-tool-mobile","15":"vue-component-book-voucher-tool-mobile","16":"vue-component-button-circle-rotating","17":"vue-component-cart-counter","18":"vue-component-cart-item-qty","19":"vue-component-cart-summary","20":"vue-component-date-picker","21":"vue-component-dropdown","22":"vue-component-faq-accordion","23":"vue-component-gallery-carousel","24":"vue-component-highlighted-list-carousel","25":"vue-component-image-zoom","26":"vue-component-location-nav","27":"vue-component-location-picker-restaurant","28":"vue-component-logo","29":"vue-component-marquee","30":"vue-component-mobile-menu","31":"vue-component-number-input","32":"vue-component-page-nav","33":"vue-component-payment-method-selector","34":"vue-component-photo-stack","35":"vue-component-product-item-qty","36":"vue-component-products-overview","37":"vue-component-products-overview-card","38":"vue-component-quest-picker","39":"vue-component-radio-list","40":"vue-component-radio-list-mobile","41":"vue-component-radio-list-restaurants","42":"vue-component-radio-list-restaurants-mobile","43":"vue-component-room-carousel","44":"vue-component-search-nav","45":"vue-component-show-more","46":"vue-component-side-cart","47":"vue-component-side-cart-add-to-bag-button","48":"vue-component-side-cart-item","49":"vue-component-simple-slider","50":"vue-component-tag-autocomplete","51":"vue-component-viempie-field","52":"vue-component-viempie-select","53":"vue-component-viempie-select-country-state"}[chunkId]||chunkId) + "." + {"0":"ad37e0f2a9034caa6359","1":"6594f9478cc0772a5ce9","2":"747ebf59c4b7a684a60f","8":"d6b3cc1a0e37d1d18d9c","9":"100cc4ad487a050cec40","10":"4c8d5fd1de867e270cbe","11":"20aa9e76634f11210424","12":"b8705f2589665021e1d5","13":"d51a81df84a77967ea6f","14":"79055f1600dd2315e54d","15":"63e229dede4ded4cca5b","16":"2587e74e5e1285261e0c","17":"6aaa44974a502254871d","18":"bb44a687aa6a7adc664b","19":"8f2c08e229ee9f2cff1a","20":"9e93be787d37f28a92ba","21":"844dabf79c3890c73cda","22":"577b6b8eb3f3becde060","23":"5f46c8843a35795e80b8","24":"4de706ccd395f35751a5","25":"7475594388a8713a3359","26":"347d86737604ab1302a7","27":"1a5d3d5adbf64d8ca263","28":"f8e4fc344f8023e3dbba","29":"52263409db18a573d758","30":"872dc184994e44b34f2f","31":"9251482c67d30f26a6f4","32":"e7c4ca0d94e34ce3cc3f","33":"f64eff0a875dd4727267","34":"19ffa1d679a64429cd04","35":"25bc73c442ed7e492412","36":"18ee2a9c785d59d2bb82","37":"9f18175d6bd8efbf8359","38":"2e16a313f9d79995f989","39":"0f74368b31f502315779","40":"80c1554aadcf34244241","41":"396b054a5077b7528e40","42":"919e1d7005d89e426749","43":"4d713ca5bd7a8252a2ab","44":"d0f424c5ff9dea1a1b1f","45":"ac85ac027a4814b068cd","46":"195bab06c8e6782a947c","47":"b90540fdb4d8cdf848e5","48":"d278cb1d40a99ad8bcf5","49":"4b825657e229d9ddf936","50":"619f5363c7e8593a2898","51":"41ca9cc19bcb22bf691f","52":"dc2bd655e1d32cfbc92b","53":"fb42ef7ab01ef2380fdf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 119);
